export default "__VITE_ASSET__a105df8a__"